import React, { useState } from 'react';

import Button from '../../shared/components/FormElements/Button/Button';
import Card from '../../shared/components/UIElements/Card';
import './EvaluationCard.css';

const EvaluationCard = props => {
    const [isHidden, setIsHidden] = useState(true);

    const showHandler = () => {
        setIsHidden(!isHidden);
    };

    if (props.title === 'Emotion') {
        return (
            <Card className='eval-card'>
            <Button transparent_100 onClick={showHandler}><b style={{ fontWeight: 600 }}>Emotion</b></Button>
            {!isHidden && <p style={{ fontWeight: 'lighter' }}>{props.emotion}</p>}
            </Card>
        );
    }

    if (props.title === 'Filler Count') {
        return (
            <Card className='eval-card'>
            <Button transparent_100 onClick={showHandler}><b style={{ fontWeight: 600 }}>Filler Word Counter</b></Button>
            {!isHidden && props.filler_count && Object.entries(props.filler_count).map(([key, value])=>{
                return <p key={key}>{key}:{value}</p>
            })}
            {!isHidden && !props.filler_count && <p>No Filler Words!</p>}
            </Card>
        );
    }


    return (
        <Card className='eval-card'>
        <Button  transparent_100 onClick={showHandler}><b style={{ fontWeight: 600 }}>{props.title}</b></Button>
        {!isHidden &&
        <div>
        <p><b>Score</b>: {props.score}</p>
        <p><b>Comments</b>: {props.comments}</p>
        <p><b>Improvements</b>: {props.improvements}</p>
        </div>
        }
        </Card>
    );
};

export default EvaluationCard;